import { motion } from "framer-motion";
import Image from "next/image";
import panda from "@rosette/assets/src/panda.svg";
import React from "react";
import { cn } from "@rosette/ts/src/util/cn.js";


interface PandaLookingProps {
    visible?: boolean;
}


export function PandaLooking({ visible }: PandaLookingProps) {
    visible ??= true;
    return (
        <motion.div
            initial={{ y: 100 }}
            animate={visible ? { y: 0 } : { y: 100 }}
            transition={visible ? { delay: 0.5, duration: 1.2 } : { duration: 1.2 }}>

            <div className={cn(
                "hover:animate-quick-wiggle motion-reduce:hover:animate-none group absolute -top-[2.5em] right-[0.2em] w-[5em] h-auto pointer-events-auto",
                "drop-shadow-lg",
            )}>
                <Image
                    className={cn(
                        "w-[5em] h-auto rotate-5 transition-transform duration-400 ease-in-out",
                        "group-hover:cursor-pointer group-hover:-translate-y-[0.5em]",
                    )}
                    src={panda}
                    alt="The Panda" />
            </div>
        </motion.div>
    );
}
